import styles from './AboutTeam.module.scss';
import { useScrollReveal } from '~/hooks/useScrollReveal';
import React from 'react';
import Image from 'next/image';

import anthony from '../../../../../assets/img/about/members/Anthony.png';
import brent from '../../../../../assets/img/about/members/Brent.png';

export const teamMembers = [
    {
        photo: anthony,
        name: 'Anthony Zhang',
        position: 'CO-FOUNDER, CEO',
        description:
            'He is a Thiel Fellow with two previous exits. His first company, EnvoyNow, was a on-demand food delivery app for college campuses. They raised $1.5M and grew to 22 college campuses before selling to JoyRun (which was acquired by Walmart this year). His second company, Know Your VC, was a Glassdoor for VCs. They grew the platform to over 200,000 unique searches a month before selling it to RateMyInvestor. Most recently, He was head of marketing at Blockfolio, a crypto portfolio app, where they grew from 1M to over 8M users in two years before it was acquired for $150M.'
    },
    {
        photo: brent,
        name: 'Brent Akamine',
        position: 'CO-FOUNDER',
        description:
            'Brent was on the founding team of Flipagram where he designed the mobile app that reached #1 in the App Store in 15 countries. They raised $70M before being acquired by TikTok. There he led the US re-launch/re-design of the TikTok App when it was expanding from China to western markets. Most recently, Brent was design director at Blockfolio with me where we bonded over our mutual love for wine.'
    }
];

export const AboutTeam = () => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { hasRevealed } = useScrollReveal({ ref });
    const runAnimation = hasRevealed ? styles.runAnimation : '';

    return (
        <section id={'Team'} className={`${styles.SectionContainer}`} ref={ref}>
            <div className={styles.SectionContent}>
                <div className={`${styles.TopContentContainer} ${runAnimation}`}>
                    <h2 className={`${styles.TopTitle} ${runAnimation}`}>Built by best-in-the-business talent</h2>
                    <p className={styles.TopDescription}>
                        Vinovest's team of experienced operators, software engineers, designers, and data scientists
                        have previously started, scaled and sold several venture-backed companies, while our wine and
                        whiskey experts bring decades of experience in vineyards, distilleries, and market sales across
                        the world.
                    </p>
                    <div className={styles.Team}>
                        {teamMembers.map((member) => (
                            <div key={member.name} className={`card`}>
                                <div className={`topInfo`}>
                                    <span className={`image`}>
                                        <Image src={member.photo.src} alt={member.name} width={126} height={126} />
                                    </span>
                                    <div>
                                        <span className={'name'}>{member.name}</span>
                                        <span className={'position'}>{member.position}</span>
                                    </div>
                                </div>
                                <p className={'description'}>{member.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
